import React from "react";
import { useNavigate } from "react-router-dom";

import { IoChevronBackOutline } from "react-icons/io5";

import { PALETTE } from "../ThemeConstants";
import { useWindowWidth } from "../../api/useWindowWidth";
import { NavbarResponsive } from "./NavbarResponsive";
import { Container } from "react-bootstrap";


export default function DetailsHeader({
  backTo, handleClose
}) {
  const [_, isMobile] = useWindowWidth();
  const navigate = useNavigate();
  const onBackClicked = handleClose ? handleClose : () => { backTo === undefined ? navigate(-1) : navigate(backTo); };
  return (
    <NavbarResponsive dark={true}>
      <Container>
        <div
          onClick={onBackClicked}
          style={{
            color: PALETTE.WHITE,
            fontSize: "18px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center"
          }}
        >
          <IoChevronBackOutline size={24} />
        </div>
      </Container>
    </NavbarResponsive>
  );
}
